export default __webpack_public_path__ + "static/media/portfolio-front.92a70bbc.png";